import React, { FunctionComponent } from 'react';
import { Accordion, AccordionDetails, Typography, Grid, AccordionSummary } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import styles from "./SiuResponseSummary.Styles";
import SiuVendorNote from "../../../../entities/SiuVendorNote.Entity";
import SiuVendorSummary from "../../../../entities/SiuVendorSummary.Entity";
import Moment from 'moment';
import { MaterialTableProps } from "material-table";
import MaterialTable from "../../../generic-components/material-table/MaterialTable.Component";

interface ISiuResponseSummaryProps {
    siuNotes: Array<SiuVendorNote>;
    siuSummary: SiuVendorSummary;
}

export const SiuResponseSummary: FunctionComponent<ISiuResponseSummaryProps> = (props: ISiuResponseSummaryProps) => {
    const classes = styles();

    // Configuración de tabla para Notes
    const notesTableProps: MaterialTableProps<SiuVendorNote> = {
        columns: [
            {
                title: "Review Notes",
                field: "reviewNotes"
            },
            {
                title: "Other Comments",
                field: "otherComments"
            },
            {
                title: "Created Date",
                field: "createdDate",
                render: rowData => <span>{Moment(rowData.createdDate).format('MM/DD/YYYY')}</span>
            }
        ],
        data: props.siuNotes ?? [],
        options: {
            selection: false,
            paging: false,
            toolbar: false
        },
    };

    return (
        <>
            {/* Summary Section - First */}
            <Accordion defaultExpanded={true} className={classes.paperFirst} square>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon className={classes.paperHeaderIcon} />}
                    aria-controls="siu-summary-content"
                    id="siu-summary-accordion"
                    className={classes.paperHeader}
                >
                    <Typography variant="subtitle2" className={classes.paperTitle}>
                        Summary
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={3} className={classes.gridContainer}>
                        {props.siuSummary ? (
                            <>
                                <Grid item xs={12} >
                                    <Typography variant="body2" className={classes.dataLabel}>
                                        Conclusion
                                    </Typography>
                                    <Typography variant="body2">
                                        {props.siuSummary.conclusion || '-'}
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} >
                                    <Typography variant="body2" className={classes.dataLabel}>
                                        Recommendation
                                    </Typography>
                                    <Typography variant="body2">
                                        {props.siuSummary.recommendation || '-'}
                                    </Typography>
                                </Grid>
                            </>
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body2" className={classes.noDataText}>
                                    No summary available yet
                                </Typography>
                            </Grid>
                        )}
                    </Grid>
                </AccordionDetails>
            </Accordion>

            {/* Notes Section - Second */}
            <Accordion defaultExpanded={true} className={classes.paper} square>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon className={classes.paperHeaderIcon} />}
                    aria-controls="siu-notes-content"
                    id="siu-notes-accordion"
                    className={classes.paperHeader}
                >
                    <Typography variant="subtitle2" className={classes.paperTitle}>
                        Notes
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Grid container spacing={3} className={classes.gridContainer}>
                        <Grid item xs={12}>
                            <MaterialTable tableProps={notesTableProps} />
                        </Grid>
                    </Grid>
                </AccordionDetails>
            </Accordion>
        </>
    );
}
